<template>
  <b-modal
    id="confirmDialog"
    no-close-on-backdrop
    hide-header-close
    no-close-on-esc
    title="Confirmar"
    centered
    v-model="modalShow"
    >{{ text }}
    <template #modal-footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="sm" variant="success" @click="resolve(true)">
        OK
      </b-button>
      <b-button size="sm" variant="danger" @click="resolve(false)">
        Cancelar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "Dialog",
  data() {
    return {
      modalShow: false,
      resolvePromisse: null,
      text: '',
    };
  },
  methods: {
    open(text) {
      this.text = text;
      this.$bvModal.show("confirmDialog");
      return new Promise((resolve, reject) => {
        this.resolvePromisse = resolve;
      });
    },
    resolve(answer) {
      this.resolvePromisse(answer);
      this.$bvModal.hide("confirmDialog");
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dialog.vue